import { Link, useParams } from 'react-router-dom';
import './OverviewItem.css';
import { OverviewItemPropsType } from '../../types';

const OverviewItem = (props: OverviewItemPropsType) => {
    const { municipalitaId, bodyType, zastupitelstvoId } = useParams();

    if (props.variant === 'list') {
        return (
            <div className='overview-item'>
                <span className='overview-item-icon material-symbols-rounded'>{props.icon}</span>
                <span className='overview-item-text'>{props.text}</span>
                {props.value.map((item, i) => (
                    <Link
                        key={i}
                        className='overview-item-value'
                        style={{ color: item.strana_barva }}
                        to={`/${municipalitaId}/${bodyType}/${zastupitelstvoId}/subjekty/${item.strana_id}`}
                    >
                        {item.strana_zkratka}
                    </Link>
                ))}
            </div>
        );
    }

    // default variant
    return (
        <div className='overview-item'>
            <span className='overview-item-icon material-symbols-rounded'>{props.icon}</span>
            <span className='overview-item-value'>{props.value}</span>
            <span className='overview-item-text'>{props.text}</span>
        </div>
    );
};

export default OverviewItem;
